// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3jnv7","placeholdersHeader":"styles_placeholdersHeader__1fQ0D","editorStyle":"styles_editorStyle__20NJ7","placeholdersBox":"styles_placeholdersBox__3zIT_"};